import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  contentContainerStyle: {
    marginTop: 12,
    flex: 1,
  },
  hintsContainerViewStyle: {
    flex: 1,
    marginRight: 19,
    marginLeft: 16,
    alignItems: 'flex-start',
    marginTop: 31,
    alignSelf: 'flex-start',
  },
  titleStyle: theme => ({
    color: theme.colors.text.primary,
    fontFamily: Fonts.type.VFFont,
    fontSize: 24,
    marginTop: 27,
    textAlign: 'center',
    marginHorizontal: 16,
    fontWeight: 'bold',
  }),
  descriptionStyle: theme => ({
    color: theme.colors.text.primary,
    fontFamily: Fonts.type.VFFont,
    fontSize: 16,
    marginTop: 7.5,
    textAlign: 'center',
    lineHeight: 24,
    marginHorizontal: 16,
  }),
  secondDescriptionStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16,
    marginTop: 32,
    textAlign: 'center',
    marginHorizontal: 16,
  }),
  secondExtraDescriptionStyle: theme => ({
    color: theme.colors.text.primary,
    fontSize: 16,
    marginTop: 4,
    textAlign: 'center',
    marginHorizontal: 16,
    fontWeight: 'bold',
  }),
  primaryButton: {
    marginTop: 32,
    marginHorizontal: 16,
  },
  secondaryButton: {
    marginTop: 16,
    marginBottom: 40,
    marginHorizontal: 16,
  },
  learnMoreHyperlinkStyle: theme => ({
    color: theme.colors.hyperlinkFive,
    textAlign: 'center',
    fontSize: 16,
    marginTop: 9,
  }),
  networkIconStyle: {
    alignSelf: 'center',
  },
});
